import {lazyRegister} from '@/Core/lazyRegister';
import './multi-selection-inner.component.css';
import template from './multi-selection-inner.component.html';
import {checkAllChildren, OptionModel, OptionSupportType} from "@components/Forms";
import '../multi-selection-item/multi-selection-item.component';
import {flattenDeep} from "@core/global";

class MultiSelectionInnerController {
    static $inject = ['$element'];

    filterText: string;
    id: string;
    useSearch: boolean;
    multiple: boolean;
    itemTemplate: string;
    private multiLevel: boolean;
    showAllOption: boolean;
    options: OptionModel[];
    selectedIds: OptionSupportType[];
    onChange: (args: { $event: OptionModel[] }) => void;

    hasSelected = false;

    constructor(
        private $element: ng.IAugmentedJQuery
    ) {
    }

    $onInit() {
        this.$element.addClass('multi-selection-inner');
        if (this.showAllOption === undefined)
            this.showAllOption = !this.options.some(option => option.value === null || option.value === '' || option.value === undefined);
    }

    $onChanges(changes: ng.IOnChangesObject) {
        if (changes.options) {
            this.options = changes.options.currentValue || [];
            this.multiLevel = this.options.some(x => x.children?.length > 0)
            this.updateHasSelected();
            return;
        }

        if (changes.selectedIds) {
            this.updateHasSelected();
        }
    }

    updateHasSelected() {
        this.options = this.options || [];

        const flatted = this.multiLevel
            ? flattenDeep(this.options)
            : this.options;

        const items = flatted.filter(x => x.checked);
        this.hasSelected = items.length > 0;
        return items;
    }

    handleUnSelectAll() {
        this.filterText = '';

        if (!this.hasSelected || !this.multiple) {
            return;
        }

        this.options.forEach(x => {
            x.checked = false;
            checkAllChildren(x, x.checked)
        });

        this.hasSelected = false;

        if (this.onChange) {
            this.onChange({$event: []});
        }
    }

    handleItemSelect(item: OptionModel) {
        if (!this.multiple) {
            if (this.onChange) {
                this.onChange({$event: !item ? [] : [item]});
            }

            return;
        }

        const selected = this.updateHasSelected();

        if (this.onChange) {
            this.onChange({$event: selected});
        }
    }
}

lazyRegister.component('multiSelectionInner', {
    template: template,
    bindings: {
        useSearch: '<?',
        options: '<',
        selectedIds: '<',
        itemTemplate: '<?',
        multiple: '<',
        showAllOption: '<?',
        id: '<?',
        onChange: '&'
    },
    controller: MultiSelectionInnerController
});
